module.exports = __webpack_public_path__ + "static/media/login_bg_7_1920x1080.318def9c.jpg";